<template>
  <div class="b:collapse" :id="id" ref="collapse">
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>


<script setup>
  import { inject, ref } from 'vue'

  const emitter = inject('emitter')   // Inject `emitter`

  const collapse = ref(null)

  defineProps({
    id: String,
  })

  emitter.on('changeState', elementId => {
    collapse.value.classList.remove('open')

    if (collapse.value.id === elementId) {
      setTimeout(() => {
        collapse.value.classList.add('open')
      }, 300)
    }
  })
</script>


<style scoped lang="scss">
  .b\:collapse {
    overflow: hidden;
    width: 100%;
    max-height: 0;
    transition: max-height .5s cubic-bezier(0.4, 0, 0.2, 1);

    .content {
      padding-block: 24px;
      padding-inline: 4px;
      height: 100%;
    }

    &.open {
      max-height: 1000px;
    }
  }
</style>
